<script>
import copyToClipBoard from '@utils/copy-to-clipboard'
import SocialShare from '@components/social-share'

export default {
    components: {
        SocialShare,
    },
    props: {
        genre: {
            type: Object,
            default: () => {},
        },
        hasViewGenreOption: {
            type: Boolean,
            default: true,
        },
        isFollowing: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        alias() {
            return this.genre.name ? this.genre.name.replace(/\s+/g, '_').toLowerCase() : ''
        },
        url() {
            const protocol = `${window.location.protocol}`
            const hostname = `${window.location.hostname}`
            const port = `${window.location.port}`
            return `${protocol}//${hostname}${port ? ':' + port : ''}${
                this.$router.resolve({ name: 'genre', params: { id: this.alias } }).href
            }`
        },
    },
    methods: {
        handleToggleFollow() {
            this.$emit('toggle-follow', this.genre)
        },
        copyLinkToClipBoard() {
            copyToClipBoard(this.url)
            this.$store.dispatch('appearance/handleNotification', {
                message: this.$m('LINK_COPIED_CLIPBOARD'),
                type: 'success',
            })
        },
    },
}
</script>

<template>
    <ul :class="$style.dropdownMenu">
        <li
            v-if="hasViewGenreOption"
            :class="$style.dropdownItem"
            @click="$router.push({ name: 'genre', params: { id: alias } })"
        >
            <BaseButton
                icon="eye"
                size="medium"
                button-type="transparent"
                @click="() => {}"
            >&nbsp; View Genre</BaseButton>
        </li>
        <div
            v-if="hasViewGenreOption"
            :class="$style.separator"
        />

        <li :class="$style.dropdownItem">
            <BaseButton
                v-if="genre"
                :icon="isFollowing ? 'minus' : 'plus'"
                size="medium"
                button-type="transparent"
                @click="handleToggleFollow"
            >
                {{ isFollowing ? 'Following' : 'Follow Genre' }}
            </BaseButton>
        </li>
        <h6 :class="$style.shareTitle">Share</h6>
        <div :class="$style.separator" />
        <li :class="$style.dropdownItem">
            <BaseButton
                icon="facebook"
                size="medium"
                button-type="transparent"
            >
                <SocialShare
                    :url="url"
                    type="facebook"
                />
            </BaseButton>
        </li>
        <li :class="$style.dropdownItem">
            <BaseButton
                icon="twitter"
                size="medium"
                button-type="transparent"
            >
                <SocialShare
                    :url="url"
                    :custom-text="`${genre.name} on @friskyradio #feelinfrisky`"
                    type="twitter"
                />
            </BaseButton>
        </li>
        <li
            :class="$style.dropdownItem"
            @click="copyLinkToClipBoard"
        >
            <BaseButton
                icon="link"
                size="medium"
                button-type="transparent"
                @click="() => {}"
            >&nbsp;Copy Genre link</BaseButton>
        </li>
    </ul>
</template>

<style lang="scss" module>
@import '@design';

.dropdown {
    &Menu {
        padding: 0;
        margin: 0;
        text-align: left;
        list-style: none;
    }
    &Item {
        display: flex;
        align-items: center;
        height: 44px;
        padding: 0 $s-m;
    }
}

.separator {
    position: relative;
    display: block;
    width: 100%;
    height: 1px;
    background: $c-mine-shaft;
}

.shareTitle {
    @extend %contentTitleM;

    margin: $s-s 0 $s-s $s-xl;
}
</style>
